import { CardContent } from "@material-ui/core";
import React, { Fragment } from "react";
import { Datagrid, FunctionField, TextField } from "react-admin";
import FilterToolbar from "../../../../../Components/FiltersToolbar/FilterToolbar";
import { DefaultPerPageSize } from "../../../../../Constants/Constant";
import { EightWingsFeedStorageStatus, EightWingsFeedStorageStatusArray } from "../../../../../Enums/EightWingsTabEnum";
import { FilterInputType, FilterTypes } from "../../../../../Enums/FilterTypes";
import RequirementCategory from "../../../../../Enums/RequirementCategory";
import { GetServiceableStatus } from "../../../../../Enums/ServiceableStatus";
import { GetUnserviceableStatus } from "../../../../../Enums/UnserviceableStatus";
import { useAppDataProvider } from "../../../../../dataprovider";
import Actions from "./Actions";
import { ExcelExport } from "../../../../../Helper/ExportExcel";
import PoolList from "../../../../../Components/PoolListComponent/PoolListComponent";
import { formatDate } from "../../../../../Helper/MomentHelper";
// import Actions from './Actions';

const CoreReturnStatusCell: React.FC<{ record: any; updateFeedStatus: (id: any, status: any) => void }> = ({ record, updateFeedStatus }) => {
  var result =
    EightWingsFeedStorageStatusArray?.find(x => x.Value === record.storageFeedStatus)?.Description ?? "";
  // Sadece storageFeedStatus değeri değiştiğinde updateFeedStatus çağrılacak
  React.useEffect(() => {
    if (record.feedServiceable?.id > 0 && record.storageFeedStatus === EightWingsFeedStorageStatus.Open) {
      result =
        EightWingsFeedStorageStatusArray?.find(x => x.Value === EightWingsFeedStorageStatus.InProgress)
          ?.Description ?? "";
      updateFeedStatus(record.id, EightWingsFeedStorageStatus.InProgress);
    }
  }, [record.storageFeedStatus, record.Id]); // storageFeedStatus değiştiğinde tetiklenecek

  return <>{result}</>;
};

export const WaitingCoreReturn = props => {
  var dataProvider = useAppDataProvider();
  const updateFeedStatus = (recordId, status) => {
    dataProvider
      .post("eightwings/updatefeedstatus", { id: recordId, status: status })
      .then(result => {})
      .catch(result => console.log(result));
  };
  const ExportToExcel = async data => {
    let headers = [
      "Ref No",
      "Requirement Category",
      "Main Svc Pn",
      "Customer PO",
      "UnSvc Pn",
      "UnSvc Sn",
      "Airport",
      "AC",
      "Requested Date",
      "Requested Delivery Date",
      "Serviceable Status",
      "Core Unit Status",
      "Core Return Status",
    ];

    var records = data.map(x => [
      x.request?.refNo || "",
      x.request?.requirementCategoryText || "",
      x.serviceable?.pn || "",
      x.request?.customerPo || "",
      x.unserviceable?.pn || "",
      x.unserviceable?.sn || "",
      x.request?.airportCode || "",
      x.request?.acRegistration || "",
      x.request?.createdDate || "",
      x.request?.requestedDeliveryDate === null
        ? "Not Arrived Yet"
        : new Date(x.request?.requestedDeliveryDate).getTime() === new Date("01/01/9999").getTime()
          ? "Exclude"
          : x.request?.requestedDeliveryDate,
      GetServiceableStatus?.find?.(s => s.Value == x?.serviceable?.status)?.Description || "",
      GetUnserviceableStatus?.find?.(s => s.Value == x?.unserviceable?.status)?.Description || "",
      EightWingsFeedStorageStatusArray?.find(s => s.Value === x.storageFeedStatus)?.Description || "",
    ]);

    ExcelExport(headers, records, "WaitingCoreReturnList");
  };
  return (
    <Fragment>
      <CardContent>
        <PoolList
          {...props}
          exporter={ExportToExcel}
          bulkActionButtons={false}
          title={"Waiting Core Return"}
          perPage={DefaultPerPageSize}
          resource={"eightwings"}
          basePath={"eightwings"}
          filterDefaultValues={{
            [`requirementCategoryText !=  "${RequirementCategory.DafzaReplenishment}" && 
                          requirementCategoryText !=  "${RequirementCategory.DafzaPriorityReplenishment}" && 
                          requirementCategoryText !=  "${RequirementCategory.CageReplenishment}" `]: "test",
          }}
          filters={
            <FilterToolbar
              dataSource={[
                {
                  style: { minWidth: "250px" },
                  source: "refNo",
                  inputType: FilterInputType.Text,
                  label: "Ref No",
                  filterType: FilterTypes.Equals,
                },
                {
                  style: { minWidth: "250px" },
                  source: "pn",
                  inputType: FilterInputType.Text,
                  label: "Pn",
                  filterType: FilterTypes.Contains,
                },
              ]}
            />
          }
        >
          <Datagrid>
            <Actions label="Actions" props={props} />
            <TextField source="request.refNo" label="Ref No" />
            <TextField source="request.requirementCategoryText" label={"Requirement Category"} />
            <TextField source="serviceable.pn" label={"Main Svc Pn"} />
            <TextField source="request.customerPo" label="Customer PO" />
            <TextField source="unserviceable.pn" label={'Core PN'} />
            <TextField source="unserviceable.sn" label={'Core SN'} />
            <TextField source="request.airportCode" label={"Airport"} />
            <TextField source="request.acRegistration" label={"AC"} />
            <FunctionField
              label="Requested Date"
              render={(record: any) => {
                return formatDate(record.request?.createdDate);
              }}
            />
            <FunctionField
              label="Requested Delivery Date"
              render={(record: any) => {
                return record.request?.requestedDeliveryDate === null
                  ? "Not Arrived Yet"
                  : formatDate(record.request?.requestedDeliveryDate, false) ==
                      formatDate(new Date("01/01/9999"), false)
                    ? "Exclude"
                    : formatDate(record.request?.requestedDeliveryDate);
              }}
            />

            <FunctionField
              label="Serviceable Status"
              render={(record: any) =>
                GetServiceableStatus?.find?.(x => x.Value == record?.serviceable?.status)?.Description ?? ""
              }
            />
            <FunctionField
              label="Core Unit Status"
              render={(record: any) =>
                GetUnserviceableStatus?.find?.(x => x.Value == record?.unserviceable?.status)?.Description ?? ""
              }
            />
            <FunctionField
              label="Core Return Status"
              render={(record: any) => (
                <CoreReturnStatusCell record={record} updateFeedStatus={updateFeedStatus} />
              )}
            />
          </Datagrid>
        </PoolList>
      </CardContent>
    </Fragment>
  );
};

export default WaitingCoreReturn;
